<div id="content">
  <div class="grid-item">
    <button class="button-add" (click)="add()">Hinzufügen</button>
  </div>
  <div class="grid-item right">
    <button class="button-export" (click)="export()">Export</button>
  </div>
  <div class="grid-item-full">
    @if (loading) {
      <div>
        <mat-spinner class="center"></mat-spinner>
      </div>
    } @else {
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="Name">
          <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">{{
            element | name
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Enroll">
          <mat-header-cell *matHeaderCellDef> Gruppen </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="enroll(element)">{{
            element | enroll
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Birthday">
          <mat-header-cell *matHeaderCellDef> Geburtsdatum </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">{{
            element.birthday | date: 'dd.MM.yyyy'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Gender">
          <mat-header-cell *matHeaderCellDef> Geschlecht </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">{{
            element | gender
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Address">
          <mat-header-cell *matHeaderCellDef> Adresse </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">{{
            element | address
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Phone">
          <mat-header-cell *matHeaderCellDef> Telefon </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">{{
            element.phone
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="E-Mail">
          <mat-header-cell *matHeaderCellDef> E-Mail </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="edit(element)">{{
            element.email
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element" class="actions">
            <mat-icon (click)="sendAccess(element)" title="App-Zugang erneut senden">qr_code</mat-icon>
            <mat-icon (click)="delete(element)">delete</mat-icon>
          </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="[
            'Name',
            'Enroll',
            'Birthday',
            'Gender',
            'Address',
            'Phone',
            'E-Mail',
            'Actions'
          ]"></mat-header-row>
        <mat-row
          *matRowDef="
            let row;
            columns: [
              'Name',
              'Enroll',
              'Birthday',
              'Gender',
              'Address',
              'Phone',
              'E-Mail',
              'Actions'
            ]
          "></mat-row>
      </mat-table>
    }

  </div>
  <div class="grid-item">
    <input
      matInput
      id="pipelineFilter"
      (keyup)="applyFilter($event)"
      placeholder="Filtern" />
    </div>
    <div class="grid-item"></div>
  </div>

  <li-student-edit
    [student]="selectedStudent"
  (closing)="commit()"></li-student-edit>
  <li-student-enroll
    *ngIf="enrollingStudent"
    [student]="enrollingStudent"
    (closing)="enrollingStudent = undefined">
  </li-student-enroll>
